import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import MerchModal from "./MerchModal";

const API_URL =
  process.env.REACT_APP_BACKEND_URL || "https://topnationapp-1-api.onrender.com";

export default function BidderProfilePopup({ profile, onClose }) {
  const [showMerch, setShowMerch] = useState(false);
  const [ownedCountries, setOwnedCountries] = useState([]);
const isMobile = window.innerWidth < 768;
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    fetch(`${API_URL}/api/user/countries`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => res.json())
      .then(data => {
        const owned = (data.countries || [])
          .filter(c => c.your_rank === 1)
          .map(c => c.country_code);
        setOwnedCountries(owned);
      })
      .catch(() => setOwnedCountries([]));
  }, []);

  if (!profile) return null;

  const openLink = (url) => {
    if (!url) return;
    if (!url.startsWith("http")) {
      window.open("https://" + url, "_blank");
    } else {
      window.open(url, "_blank");
    }
  };

  return (
    <>
      <div
       style={{
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.85)",
  zIndex: 99999,
  display: "flex",

  alignItems: "flex-start",   // ✅ FIX
  justifyContent: "center",

  overflowY: "auto",          // ✅ FIX
  padding: "20px 10px"        // ✅ FIX
}}
      >
        <div
          onClick={(e) => e.stopPropagation()}
         style={{
  width: isMobile ? "88%" : "min(90%, 360px)",   // 👈 menšie ako predtým
  maxHeight: "90vh",

  background: "#0A0A0A",
  border: "1px solid #FFD700",
  borderRadius: "16px",

  padding: isMobile ? "16px" : "24px",           // 👈 menej paddingu

  color: "white",
  textAlign: "center",
  position: "relative",

  overflow: "auto",                           // 👈 FIX
  display: "flex",
  flexDirection: "column"
}}
        >
          <button
            onClick={onClose}
            style={{
              position: "absolute",
              top: 12,
              right: 16,
              background: "none",
              border: "none",
              color: "#FFD700",
              fontSize: "18px",
              cursor: "pointer"
            }}
          >
            ✕
          </button>

          <h2
            style={{
              color: "#FFD700",
              fontSize: "24px",
              marginBottom: "14px"
            }}
          >
            {profile.name || "Unknown"}
          </h2>

          <div
            style={{
              marginBottom: "14px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            {profile.avatar ? (
              <img
                src={profile.avatar}
                alt=""
                style={{
                  width: "90px",
                  height: "90px",
                  borderRadius: "50%",
                  border: "2px solid #FFD700",
                  objectFit: "cover"
                }}
              />
            ) : (
              <div
                style={{
                  width: "90px",
                  height: "90px",
                  borderRadius: "50%",
                  border: "2px solid #FFD700",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "30px"
                }}
              >
                👤
              </div>
            )}
          </div>

          <div
            style={{
              color: "#FFD700",
              marginBottom: "10px",
              fontSize: "15px"
            }}
          >
            💰 €{Number(profile.amount || 0).toFixed(2)}
          </div>

          {profile.category && (
            <div
              style={{
                display: "inline-block",
                border: "1px solid #FFD700",
                borderRadius: "20px",
                padding: "4px 12px",
                marginBottom: "10px",
                fontSize: "12px"
              }}
            >
              {profile.category}
            </div>
          )}

          {profile.company_name && (
            <div style={{ marginBottom: "8px" }}>
              🏢 {profile.company_name}
            </div>
          )}

          {profile.description && (
            <p
              style={{
                color: "#ccc",
                fontSize: "13px",
                marginBottom: "12px"
              }}
            >
              {profile.description}
            </p>
          )}

          <div style={{ marginBottom: "16px", overflowY: "auto" }}>
  {profile.website && (
    <div
      onClick={() => openLink(profile.website)}
      style={{ color: "#FFD700", cursor: "pointer" }}
    >
      🌐 Website
    </div>
  )}

  {profile.instagram && (
    <div
      onClick={() => openLink(profile.instagram)}
      style={{ color: "#FFD700", cursor: "pointer" }}
    >
      📸 Instagram
    </div>
  )}

  {profile.facebook && (
    <div
      onClick={() => openLink(profile.facebook)}
      style={{ color: "#FFD700", cursor: "pointer" }}
    >
      👍 Facebook
    </div>
  )}

  {profile.linkedin && (
    <div
      onClick={() => openLink(profile.linkedin)}
      style={{ color: "#FFD700", cursor: "pointer" }}
    >
      💼 LinkedIn
    </div>
  )}
</div>

          <button
            onClick={() => setShowMerch(true)}
            style={{
              background: "#FFD700",
              color: "#000",
              padding: "12px",
              border: "none",
              borderRadius: "8px",
              fontWeight: "bold",
              cursor: "pointer",
              width: "100%",
              marginBottom: "12px",
              fontSize: "15px"
            }}
          >
            👕 GET MERCH
          </button>

          <button
            onClick={onClose}
            style={{
              background: "#FFD700",
              color: "#000",
              padding: "10px 20px",
              border: "none",
              borderRadius: "6px",
              fontWeight: "bold",
              cursor: "pointer"
            }}
          >
            Close
          </button>
        </div>
      </div>

      {showMerch &&
        createPortal(
          <MerchModal
            isOpen={showMerch}
            onClose={() => setShowMerch(false)}
            countryCode={profile.country_code}
            ownedCountries={ownedCountries}
          />,
          document.body
        )}
    </>
  );
}
